import { useEffect, useRef, useState, forwardRef } from "react";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  maxLength?: number;
  placeholder?: string;
  errorMessage?: string;
}

const CountTextInput = forwardRef<HTMLInputElement, Props>(({
  maxLength,
  placeholder,
  className,
  id,
  onChange,
  errorMessage,
  ...props
}, ref) => {
  const [letterCount, setLetterCount] = useState(0);
  const [outlineClassname, setOutlineClassname] = useState("");

  const inputRef = useRef<HTMLInputElement | null>(null);

  const setRefs = (element: HTMLInputElement | null) => {
    inputRef.current = element;
    if (typeof ref === 'function') {
      ref(element);
    } else if (ref) {
      ref.current = element;
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      setLetterCount(inputRef.current.value.length);
    }
  }, [inputRef.current?.value.length]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLetterCount(e.target.value.length);

    if (onChange) {
      onChange(e);
    }
  };

  const [isFocused, setIsFocused] = useState(false);

  return (
    <div>
      <div className={`${className} flex flex-col h-full rounded-[0.5rem]`}>
        <div
          className={`
          h-full flex flex-row justify-between gap-3 border-[0.0625rem] rounded-[0.5rem] p-[11.5px] bg-transparent
          ${errorMessage ? "border-[#F24A4A]" : ""}
          ${isFocused && !errorMessage ? "border-[#4285F4]" : ""}
          ${!isFocused && !errorMessage ? "border-[#d9d9d9]" : ""}
          `}
          style={{ borderColor: outlineClassname }}
        >
          <input
            {...props}
            ref={setRefs}
            type="text"
            placeholder={placeholder}
            className="h-full bg-transparent w-full text-[14px] outline-none"
            maxLength={maxLength}
            onChange={handleChange}
            onFocus={(e) => {
              setIsFocused(true);
            }}
            onBlur={(e) => {
              setIsFocused(false);
            }}
          />
          <div className="text-nowrap text-[#787A7D]">
            {letterCount}/{maxLength}자
          </div>
          {errorMessage ? (
            <div className="flex items-center">
              <img
                className="w-[1.5rem]"
                alt="alert icon"
                src="/assets/icons/alerticon.svg"
              />
            </div>
          ) : null}
        </div>
      </div>
      {errorMessage && (
        <div className="text-[12px] mt-[0.25rem] text-[#F24A4A]">
          {errorMessage}
        </div>
      )}
    </div>
  );
});

export default CountTextInput;
